import React from 'react';
import { useNavigate } from 'react-router-dom';
import './NotFound.css';

const NotFound = () => {
  const navigate = useNavigate();

  return (
        <div className="notfound-container">
          <h1>404 - Page Not Found</h1>
          <p>Oops! This page doesn't exist.</p>
          <img
            src="https://images.pexels.com/photos/32342274/pexels-photo-32342274/free-photo-of-close-up-of-hippopotamus-submerged-in-tanzania-river.jpeg"            
            alt="Hippo"
            className="hippo-image"
          />
        </div>
    );
};

export default NotFound;
